import { render, staticRenderFns } from "./AddAdvance.vue?vue&type=template&id=0d79ffdc&"
import script from "./AddAdvance.vue?vue&type=script&lang=js&"
export * from "./AddAdvance.vue?vue&type=script&lang=js&"
import style0 from "./AddAdvance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports